<mat-form-field appearance="outline" class="w-100" color="primary" subscriptSizing="dynamic">
    <mat-label>{{ title }}</mat-label>
    <input [disabled]="disabled" [formControl]="userSearchControl"
           [matAutocomplete]="auto"
           [placeholder]="placeholder" [readonly]="disabled" matInput>
    <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selectUserById($event.option.value)"
        [displayWith]="displayFn">
        @for (user of filteredUsers; track user.id) {
            <mat-option [value]="user.id">
                {{ nameDisplay(user) }}
            </mat-option>
        }
    </mat-autocomplete>
    @if (userSearchControl?.value?.id && !disabled) {
        <button (click)="this.userSearchControl.setValue(null); this.userSelect.emit(undefined); this.filteredUsers = [];"
                aria-label="Clear Search" mat-icon-button
                matSuffix>
            <mat-icon>close</mat-icon>
        </button>
    }
    @if (loadingUsers) {
        <mat-spinner [diameter]="20" aria-label="Searching users" matSuffix></mat-spinner>
    }
    <mat-hint>A minimum of 3 characters is required to search</mat-hint>
</mat-form-field>
